import React, { Component } from 'react';
import {
  Label,
  Input,
} from 'reactstrap';

import classNames from 'classnames';

import './RatingResponse.scss';

class RatingResponse extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    // Validate for case of edit
    this.handleInput(this.props.value.rating);
  }

  // ----------------------
  // Computed
  // ----------------------

  get ratings() {
    return Array.from(Array(this.props.scale).keys());
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput(value) {
    const valueObject = {
      isValid: true,
      rating: value,
    };
    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="rating-response">
        <Label>{this.props.prompt}</Label>
        <div className={classNames('rating-field-set', { unselected: this.props.value.rating === 0 })}>
          {this.ratings.map(index => (
            <label
              className={classNames('rating-field', { checked: this.props.value.rating === (index + 1) })}
              htmlFor={(index + 1).toString()}
              key={index}
            >
              <i className="fa fa-star" />
              <div className="star-number">{index + 1}</div>
              <Input
                checked={this.props.value.rating === (index + 1)}
                id={(index + 1).toString()}
                name={this.props.name}
                onChange={() => this.handleInput((index + 1))}
                type="radio"
              />
            </label>
          ))}
        </div>
      </div>
    );
  }
}

export default RatingResponse;

